import { GlobalButtonStyle } from '@website-builder/model/style/global-button-style';

export class AccordionButtonStyle extends GlobalButtonStyle {
  marginTop = 'uk-margin-top';

  static normalize(styles: Partial<AccordionButtonStyle>): AccordionButtonStyle {
    const globalButtonStyle: GlobalButtonStyle = GlobalButtonStyle.normalize(styles);
    const pureStyles = new AccordionButtonStyle();

    Object.assign(pureStyles, globalButtonStyle);

    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;

    return pureStyles;
  }
}
